import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component } from '@wordpress/element';
import { filter } from 'lodash';
import PropTypes from 'prop-types';
/**
 * WooCommerce dependencies
 */

import { presetValues } from '@woocommerce/date';
/**
 * Internal dependencies
 */

import SegmentedSelection from '../segmented-selection';

var PresetPeriods =
/*#__PURE__*/
function (_Component) {
  _inherits(PresetPeriods, _Component);

  function PresetPeriods() {
    _classCallCheck(this, PresetPeriods);

    return _possibleConstructorReturn(this, _getPrototypeOf(PresetPeriods).apply(this, arguments));
  }

  _createClass(PresetPeriods, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          period = _this$props.period;
      return createElement(SegmentedSelection, {
        options: filter(presetValues, function (preset) {
          return preset.value !== 'custom';
        }),
        selected: period,
        onSelect: onSelect,
        name: "period",
        legend: __('select a preset period', 'woocommerce-admin')
      });
    }
  }]);

  return PresetPeriods;
}(Component);

PresetPeriods.propTypes = {
  onSelect: PropTypes.func.isRequired,
  period: PropTypes.string
};
export default PresetPeriods;
//# sourceMappingURL=preset-periods.js.map